import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import { PHONES } from 'styles/media-queries'
import * as MQ from 'styles/media-queries'

const { unit, half } = measures

export const filtersWrapper = css`
  ${PHONES} {
    display: flex;
    flex-direction: column;
  }
`

export const phoneSpace = css`
  ${PHONES} {
    margin-bottom: ${unit * 4}px;
  }
`

export const wrapButton = css`
  margin-top: ${half}px;
  ${MQ.LAPTOPS_DESKTOPS} {
    margin-bottom: ${unit * 4}px;
  }
  ${MQ.TABLETS_IPADS_PORTRAIT} {
    margin-bottom: ${unit * 4}px;
  }
`
